var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      attrs: {
        icon: "mdi-information-variant",
        color: "info",
        title: _vm.active && _vm.active.property && _vm.active.property.name,
        boilerplate: ""
      },
      on: { close: _vm.handleCloseClick },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _vm.active && _vm.active.id && _vm.isHISDisabled(_vm.active)
                ? _c(
                    "request-actions",
                    {
                      attrs: {
                        assigned: _vm.active.dispatched === "O",
                        entity_nav_full_id: _vm.active.entity_nav_full_id,
                        entityOrdo: _vm.active.entity_ordo === "O",
                        groupId: _vm.active.group_id,
                        item: _vm.active,
                        paused: _vm.isActivePaused === "O",
                        "property-id": _vm.active.property_id,
                        qualification: _vm.active.work_order_group_qualif_code,
                        rejected: _vm.active.rejected === "O",
                        requestId: _vm.active.id,
                        requestOrdo: _vm.active.property.request_ordo === "O",
                        status: _vm.active.status,
                        symptom: _vm.active.work_order_group_type_code,
                        technician_internal_id:
                          _vm.active.technician_internal_id,
                        TPEM: _vm.active.his_treatment === "Traitement PEM"
                      }
                    },
                    [
                      _vm.property.m2m_remotemanagement_enabled
                        ? _c("link-to-cofely-vision", {
                            attrs: {
                              "has-label": "",
                              numins: _vm.property.id,
                              region: _vm.property.entity_region
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm.active &&
                  _vm.active.id &&
                  _vm.property.m2m_remotemanagement_enabled
                ? _c("link-to-cofely-vision", {
                    staticClass: "mr-3",
                    attrs: {
                      numins: _vm.property.id,
                      region: _vm.property.entity_region
                    }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: _vm.stateClass,
          staticStyle: { height: "100%" }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex elevation-5 left-side" },
            [
              _c("request-left-side", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sidePanelIsOpen,
                    expression: "sidePanelIsOpen"
                  }
                ],
                staticClass: "overflow-y-auto overflow-x-hidden",
                style: { height: _vm.height + "px" },
                on: { requestLogsOpen: _vm.handleLeftSideWidthChange }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  style: { height: _vm.height + "px" }
                },
                [
                  _c("div", { staticClass: "primary menu-bar" }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      staticStyle: { position: "relative", left: "11px" },
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.handleToggleLeftPanel }
                    },
                    [
                      _c("v-icon", { attrs: { color: "background" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.sidePanelIsOpen
                                ? "navigate_before"
                                : "navigate_next"
                            ) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pl-3 right-side",
              staticStyle: { position: "relative" }
            },
            [_c("request-right-side")],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }